(() => {
  function initDeliverySelector(section) {
    if (!section || section.dataset.deliveryReady === 'true') return;

    const form = section.querySelector('[data-delivery-form]');
    if (!form) return;

    section.dataset.deliveryReady = 'true';

    const choices = [...form.querySelectorAll('input[name="delivery-method"]')];
    const choiceCards = [...form.querySelectorAll('[data-delivery-choice]')];
    const pickupDetails = form.querySelector('[data-locker-details]');
    const locationCode = form.querySelector('[data-locker-code]');
    const pickupLocation = form.querySelector('[data-locker-location]');
    const locationConfirmation = form.querySelector('[data-locker-confirmation]');
    const submit = form.querySelector('[data-delivery-submit]');
    const submitLabel = form.querySelector('[data-delivery-submit-label]');
    const error = form.querySelector('[data-delivery-error]');

    function selectedMethod() {
      return choices.find(choice => choice.checked)?.value || '';
    }

    function locationCodeValue() {
      return (locationCode?.value || '').trim();
    }

    function pickupIsValid() {
      return (
        locationCodeValue().length > 0 &&
        (pickupLocation?.value || '').trim().length >= 3 &&
        Boolean(locationConfirmation?.checked)
      );
    }

    function sync() {
      const method = selectedMethod();
      const isPickup = method === 'Courier Guy pickup location';

      choiceCards.forEach(card => {
        const input = card.querySelector('input[name="delivery-method"]');
        card.classList.toggle('is-selected', Boolean(input?.checked));
      });

      if (pickupDetails) {
        pickupDetails.hidden = !isPickup;
      }

      if (submit) {
        submit.disabled = !method || (isPickup && !pickupIsValid());
      }

      if (submitLabel) {
        if (!method) submitLabel.textContent = 'Choose a delivery method';
        else if (isPickup) submitLabel.textContent = 'Save location & continue';
        else submitLabel.textContent = 'Continue to checkout';
      }

      if (error && (!isPickup || pickupIsValid())) {
        error.hidden = true;
        error.textContent = '';
      }
    }

    choices.forEach(choice => choice.addEventListener('change', sync));
    pickupLocation?.addEventListener('input', sync);
    locationConfirmation?.addEventListener('change', sync);
    locationCode?.addEventListener('input', sync);
    locationCode?.addEventListener('blur', () => {
      locationCode.value = locationCodeValue();
      sync();
    });

    form.addEventListener('submit', async event => {
      event.preventDefault();

      const method = selectedMethod();
      const isPickup = method === 'Courier Guy pickup location';

      if (!method || (isPickup && !pickupIsValid())) {
        if (error) {
          error.textContent = !method
            ? 'Choose door-to-door or a Courier Guy pickup location to continue.'
            : 'Enter the Courier Guy location code and name, then confirm the details.';
          error.hidden = false;
        }

        if (!method) choices[0]?.focus();
        else if (!locationCodeValue()) locationCode?.focus();
        else if ((pickupLocation?.value || '').trim().length < 3) pickupLocation?.focus();
        else locationConfirmation?.focus();
        return;
      }

      submit.disabled = true;
      form.classList.add('is-saving');
      if (submitLabel) submitLabel.textContent = 'Saving delivery';

      const attributes = {
        'Delivery method': method,
        'Fulfilment app': isPickup ? 'The Courier Guy Connect' : 'Bob Go',
        'Courier Guy location code': isPickup ? locationCodeValue() : '',
        'Courier Guy pickup location': isPickup ? pickupLocation.value.trim() : '',
        'Courier Guy location confirmed': isPickup ? 'Yes' : '',
        'Courier Guy locker code': '',
        'Courier Guy locker location': '',
        'Courier Guy locker confirmed': ''
      };

      const root = section.dataset.cartRoot || '/';

      try {
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ attributes })
        });

        if (!response.ok) throw new Error('Cart update failed');
        window.location.assign(section.dataset.checkoutUrl || '/checkout');
      } catch (requestError) {
        form.classList.remove('is-saving');
        submit.disabled = false;
        if (submitLabel) submitLabel.textContent = isPickup ? 'Save location & continue' : 'Continue to checkout';
        if (error) {
          error.textContent = 'We could not save your delivery choice. Please try again.';
          error.hidden = false;
        }
      }
    });

    sync();
  }

  document.querySelectorAll('[data-delivery-selector]').forEach(initDeliverySelector);
  document.addEventListener('shopify:section:load', event => {
    initDeliverySelector(event.target.querySelector?.('[data-delivery-selector]'));
  });
})();
